<template>
  <div class="farmcommentApp" :style="'height:'+curHeight+'px;background:url('+bg+') no-repeat;background-size:100% 100% !important;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div style="height:55px;"></div>
    <div class="pl">
      <h2>您的评论：</h2>
      <textarea v-model="content" placeholder="菜园怎么样？说说您的体会吧！"></textarea>
      <button @click="save">提交</button>
    </div>
    
  </div>
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        userData:[],
        code:'',
        content:'',
        bg:require('../../assets/images/farm.png'),
      };
    },

    beforeMount() {
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/farm');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }else{
        this.userData = JSON.parse(localStorage.getItem('userjwt'));
      }
    },
    mounted() {
      this.beforeMount();
      if(localStorage.getItem('userjwt') == null){
        this.login();
      }
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },


      save:function(){
        if(this.content == ''){
          this.$alert('请输入评论内容！', '警告', {
            confirmButtonText: '确定',
            showClose:false
          });
          return false;
        }
        var id = this.$route.query.id;
        var that = this;
        that.fullscreenLoading = true;
        that.axios({
          method:'post',
          url:that.$host+'home/farm/saveComment',
          params:{
            content:that.content,
            user_id:that.userData.id,
            f_id:id,
            reply_id:that.userData.id,
            reply_user:that.userData.username
          }
        }).then(function(response){
          that.fullscreenLoading = false;
          if(response.data.status == 200){
            that.$router.go(-1);
          }else{
            that.$alert(response.data.message, '警告', {
              confirmButtonText: '确定',
              showClose:false
            });
          }
        }).catch(err=>{

        });
        
      },


      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          that.userData = res.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .farmcommentApp{
    max-width:640px;
    margin:0 auto;
    background-size: 100% 100%;
    overflow-y: scroll;
  }
  .farmcommentApp .pl{
    background: rgba(255,255,255,0.8);
    border-radius: 10px;
    display:block;
    width:92%;
    margin:0 auto;
    padding-bottom:30px;
  }
  .farmcommentApp .pl h2{
    display:block;
    width:92%;
    margin:0 auto;
    color:#999;
    font-size:15px;
    padding:10px 0
  }
  .farmcommentApp .pl textarea{
    display:block;
    width:86%;
    margin:0 auto;
    height: 250px;
    background: rgba(255, 255, 255, 0);
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.15);
    border-radius: 10px;
    border:none;
    outline:none;
    padding:10px
  }
  .farmcommentApp .pl button{
    display:block;
    width:92%;
    height: 40px;
    background: #00D138;
    border-radius: 10px;
    border:none;
    margin:0 auto;
    color:#fff;
    font-size:15px;
    margin-top:30px
  }

</style>